type PreviewInputElement = HTMLTextAreaElement | HTMLInputElement;

export class OgpPreviewListener {
    public static bindPreviewInput(textareaElement: PreviewInputElement, onInput: (event: Event) => void): void {
        textareaElement.addEventListener("input", onInput);
    }
}
